import React from 'react';
import { ITagsListProps } from './~types/TagsListProps';
import { ISearchingTag, TagName, TagType } from '../~types/models/SearchingTag';
import { DEFAULT_OPERATOR_AVATAR_ID } from 'src/app/operator/~store/models/ModelsConstants';
import { Avatar } from '@mui/material';
import ContactIcon from '@mui/icons-material/AccountCircle';
import OperatorIcon from '@mui/icons-material/SupportAgent'

import './TagsList.css';
import { GET_FILE_BY_ID_API_ROUTE } from 'src/app/chats-panel/~api/apiRoutes';
import { ContactTagValue } from '../../../helpers/contact-tag-value/ContactTagValue';

const TagsList = (props: ITagsListProps) => {

    const _createTag = (tag: ISearchingTag, key: number) => {
        const renderSwitch = (tagType: TagType) => {
            switch(tagType) {
                case TagType.OpeningTag:
                case TagType.OperationTag:
                    return tag.value as string;

                case TagType.ClosingTag: {
                    switch(tag.tagName) {
                        case TagName.Status:
                        case TagName.ChatTag:
                        case TagName.Channel:
                        case TagName.Date:
                        case TagName.Setting:
                        case TagName.Subject:
                        case TagName.Source:
                        case TagName.ChatNumber:
                        case TagName.ContactName:
                        case TagName.Phone:
                        case TagName.ChatName:
                        case TagName.TriggerName: 
                        case TagName.Answer:
                        case TagName.ChatType:
                        case TagName.MessengerExternalId:
                        case TagName.MessengerNickname:
                        case TagName.OperatorType:
                            return tag.value as string;
                        
                        case TagName.ChannelName:
                            tag.externalValue = `${props.channels.find(el => {return el.name === tag.value})?.channelId}`;
                            return tag.value as string;

                        case TagName.Operator:
                            tag.externalValue = `${props.operators.find(el => { return el.name === tag.value })?.operatorId}`;
                            return _createOperatorTag(Number.parseInt(tag.externalValue));
                        
                        case TagName.Contact:
                            tag.externalValue = tag.externalValue ?? `${props.contacts.find(el => { return ContactTagValue(el) === tag.value})?.contactId}`;
                            return _createContactTag(Number.parseInt(tag.externalValue));

                        case TagName.ContactExernalId:
                            tag.externalValue = tag.value;
                            return tag.value as string;

                        case TagName.Phrase:
                            return tag.value as string;
                    }
                }
            }
        }
        return (
            <div
                className="tags-list__tag"
                data-testid="search-tag"
                data-tag-type={tag?.tagType}
                data-tag-name={tag?.tagName}
                key={key}>
                {renderSwitch(tag.tagType)}
                {tag.tagType === TagType.ClosingTag &&
                <div
                    className="tags-list__tag--close"
                    data-testid="search-tag-remove"
                    onClick={() => props.onCloseTag(tag)}>
                    <i className="material-icons">close</i>
                </div>}
            </div>
        )
    }

    const _createOperatorTag = (operatorId: number) => {
        const operator = props.operators.find(operator => operator.operatorId === operatorId);
        if(operator) {
            const imageUrl = 
                operator.avatarId !== DEFAULT_OPERATOR_AVATAR_ID ? 
                GET_FILE_BY_ID_API_ROUTE + operator.avatarId : 
                "";
            return (
                <div className="operator-tag__container">
                    <Avatar
                        className="operator-tag__avatar"
                        src={imageUrl}
                    >
                        <OperatorIcon style={{ color: "#26a69a" }} />
                    </Avatar>
                    {operator.name}
                </div>
            )
        } else {
            return <></>
        }
    }

    const _createContactTag = (contactId: number) => {
        const contact = props.contacts.find(contact => contact.contactId === contactId);
        
        const imageUrl = (contact === undefined || contact.avatarId === null) ?
            "" :
            GET_FILE_BY_ID_API_ROUTE + contact.avatarId;
        return (
            <div className="operator-tag__container">
                <Avatar
                    className="operator-tag__avatar"
                    src={imageUrl}
                >
                    <ContactIcon style={{ color: "#26a69a" }} />
                </Avatar>
                {(contact !== undefined ? ContactTagValue(contact) : contactId)}
            </div>
        )
    }

    return (
        <div className="tags-list__container">
            {props.tags.map((tag, i) => {
                return _createTag(tag, i);
            })}
        </div>)
}

export default TagsList;